/* global Shopify */
/* global _iub */
class FormValidator {
    constructor() {
        this.MAIL_FORMAT = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        this.PSW_MATCH_1 = /.*\d.*/;
        this.PSW_MATCH_2 = /.*[a-z].*/;
        this.PSW_MATCH_3 = /.*[A-Z].*/;
        this.PSW_MATCH_4 = /.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?].*/;

        this.sidebar = document.querySelector('sidebar-panel') || false;

        this.init();
    }

    init() {
        document.querySelectorAll('form').forEach(
            form => {
                let submit = form.querySelectorAll('*[type="submit"]:not(.btn_update)') || [];
                submit.forEach(
                    el => {
                        el.addEventListener('click', (ev) => {

                            if (this.checkForm(form)) {

                                if (form.id === 'footer_box_newsletter') {
                                    if (this.sidebar) {
                                        this.sidebar.openSidebar('newsletter');
                                        this.sidebar.querySelector('input[name="contact[email]"]')
                                            .value = form.querySelector('input').value;
                                    }

                                    ev.preventDefault();
                                }

                                let input_tags = form.querySelector(
                                    'input[name="customer[tags]"],input[name="contact[tags]"]'
                                ) || false;

                                if (input_tags) {
                                    let value = '';
                                    let type = 'signup';
                                    if (form.id === 'contact_form') {
                                        type = 'newsletter';
                                    }

                                    let language = document.documentElement.lang;

                                    value =
                                        `${type},language_${document.documentElement.lang}`;
                                    let profiling = form.querySelector(
                                        'input[name="profiling_privacy"]') || false;
                                    let newsletter_preference = form.querySelector(
                                        'input[name="customer[accepts_marketing]"') || false;

                                    if (profiling) {
                                        let consent_profiling = profiling.checked ?
                                            "consenso_profilazione:true" :
                                            "consenso_profilazione:false";
                                        value = `${value},${consent_profiling}`;
                                    }

                                    if (newsletter_preference) {
                                        let consent_newsletter = newsletter_preference.checked ?
                                            "consenso_newsletter:true" :
                                            "consenso_newsletter:false";
                                        value = `${value},${consent_newsletter}`;

                                        if (newsletter_preference.checked) {
                                            let preference = this.getNewsletterPreferenceTag(form)
                                                .join(',');
                                            value =
                                                `${value},preference:${preference}`;
                                            this.createInput(form, 'Preference', preference,
                                                'customer');
                                        }
                                    }

                                    if (form.id === 'contact_form') {
                                        value = `${value}, consenso_newsletter:true`;
                                        let preference = this.getNewsletterPreferenceTag(form).join(
                                            ',');
                                        value = `${value},preference:${preference}`;

                                        this.createInput(form, 'Preference', preference, 'contact');
                                        this.createInput(form, 'Language', language, 'contact');
                                    } else {
                                        this.createInput(form, 'Language', language, 'customer');
                                    }

                                    input_tags.value = value;
                                }

                                if (form.id === 'register_sidebar' || form.id === 'contact_form') {
                                    ev.preventDefault();

                                    let ip = form.querySelector('input.customerip');

                                    if (form.id === 'register_sidebar') {
                                        _iub.cons_instructions.push(["load", {
                                            submitElement: el,
                                            form: {
                                                selector: form,
                                                map: {
                                                    subject: {
                                                        first_name: "customer[first_name]",
                                                        last_name: "customer[last_name]",
                                                        email: "customer[email]",
                                                        full_name: ip.id
                                                    },
                                                    preferences: {
                                                        consenso_newsletter: "customer[accepts_marketing]",
                                                        informativa_privacy: "customer[accepts_marketing]",
                                                        consenso_profilazione: "profiling_privacy_1"
                                                    }
                                                }
                                            },
                                            consent: {
                                                legal_notices: [{
                                                        identifier: 'privacy_policy',
                                                    },
                                                    {
                                                        identifier: 'cookie_policy',
                                                    },
                                                    {
                                                        identifier: 'term',
                                                    }
                                                ],
                                            }
                                        }]);
                                    } else if (form.id === 'contact_form') {
                                        _iub.cons_instructions.push(["load", {
                                            submitElement: el,
                                            form: {
                                                selector: form,
                                                map: {
                                                    subject: {
                                                        email: "contact[email]",
                                                        full_name: ip.id
                                                    },
                                                    preferences: {
                                                        consenso_newsletter: "typecontent",
                                                        informativa_privacy: "typecontent",
                                                        consenso_profilazione: "privacyf"
                                                    }
                                                }
                                            },
                                            consent: {
                                                legal_notices: [{
                                                        identifier: 'privacy_policy',
                                                    },
                                                    {
                                                        identifier: 'cookie_policy',
                                                    },
                                                    {
                                                        identifier: 'term',
                                                    }
                                                ],
                                            }
                                        }]);
                                    }

                                    form.submit();
                                }

                            } else {
                                ev.preventDefault();
                            }
                        });
                    });
            }
        );

        document.querySelectorAll(
            '#register_sidebar input[type="password"] , #create_customer input[type="password"]').forEach(
            element => {
                element.addEventListener('input', (e) => {
                    this.validatePsw(e.target);
                });
            });

        document.querySelectorAll('form input[type="password"]').forEach(password => {
            password.parentNode.querySelectorAll('.show-psw').forEach(
                eye_box => {
                    eye_box.addEventListener('click', () => {
                        let eye = eye_box.querySelector('.eye');
                        let eye_slash = eye_box.querySelector('.eye-slash');

                        eye.hidden = !eye.hidden;
                        eye_slash.hidden = !eye_slash.hidden;

                        let type = password.getAttribute('type') === 'password' ? 'text' :
                            'password';
                        password.type = type;
                    });
                }
            );
        });

        $.getJSON("https://api.ipify.org?format=json", function(data) {
            document.querySelectorAll('input.customerip').forEach(
                ip => {
                    ip.value = data.ip;
                }
            );
        });

        if (!Shopify.isMobileDisplay()) {
            document.querySelectorAll('#birthday_1, #birthday_nwsl').forEach(
                element => {
                    if (!Shopify.isMobileDisplay()) {
                        element.type = 'text';
                        element.setAttribute("onfocus", "this.type='date'; this.classList.remove('text-end');");
                        element.setAttribute("onblur", "this.type='text'; this.classList.add('text-end');");
                    }
                }
            );
        }
    }

    getNewsletterPreferenceTag(form) {
        let tags = [];
        form.querySelectorAll('input[name="newsletter_preference"]')
            .forEach(
                tag => {
                    if (tag.checked) {
                        tags.push(tag.value);
                    }
                }
            );
        return tags;
    }

    checkForm(form) {
        let input_to_validate = form.querySelectorAll('.has-validation input, .has-validation textarea') || [];

        let is_valid = true;

        input_to_validate.forEach(
            input => {
                if (input.tagName.toLowerCase() === 'textarea') {
                    if (!this.validateText(input)) {
                        input.classList.add('is-invalid');
                        is_valid = false;
                        return;
                    }
                    input.classList.remove('is-invalid');
                    return;
                }

                switch (input.type) {
                    case 'email':
                        if (!this.validateText(input)) {
                            this.showAnInvalidFeedback(input, 'is-required-input');
                            input.classList.add('is-invalid');
                            is_valid = false;
                            return;
                        } else if (!this.validateEmail(input)) {
                            this.showAnInvalidFeedback(input, 'invalid-email');
                            input.classList.add('is-invalid');
                            is_valid = false;
                            return;
                        }
                        input.classList.remove('is-invalid');
                        break;
                    case 'text':
                    case 'date':
                    case 'search':
                        if (!this.validateText(input)) {
                            input.classList.add('is-invalid');
                            is_valid = false;
                            return;
                        }
                        input.classList.remove('is-invalid');
                        break;
                    case 'password':
                        if (!this.validateText(input)) {
                            this.showAnInvalidFeedback(input, 'is-required-input');
                            input.classList.add('is-invalid');
                            is_valid = false;
                            return;
                        } else if (!this.validatePsw(input)) {
                            is_valid = false;
                            return;
                        }

                        input.classList.remove('is-invalid');
                        break;
                    case 'checkbox':
                        if (!input.checked) {
                            input.classList.add('is-invalid');
                            is_valid = false;
                            return;
                        }

                        input.classList.remove('is-invalid');
                        break;
                }
            }
        );

        return is_valid;

    }

    validateEmail(input) {
        return input.value.match(this.MAIL_FORMAT);
    }

    validateText(text) {
        return text.value !== "";
    }

    validatePsw(password) {
        if (password.classList.contains('password_confirmation')) {
            let confirmation = document.getElementById(password.dataset.confirmation);

            if (password.value !== confirmation.value) {
                this.showAnInvalidFeedback(password, 'error-missmatch');

                password.classList.remove('is-valid');
                password.classList.add('is-invalid');

                return false;
            } else {
                password.classList.add('is-valid');
                password.classList.remove('is-invalid');

                return true;
            }
        }

        if (password.value.length < 8) {
            this.showAnInvalidFeedback(password, 'lenght_password_validation');

            password.classList.remove('is-valid');
            password.classList.add('is-invalid');
            return false;
        }

        let count = 0;

        if (password.value.match(this.PSW_MATCH_1)) {
            count++;
        }
        if (password.value.match(this.PSW_MATCH_2)) {
            count++;
        }
        if (password.value.match(this.PSW_MATCH_3)) {
            count++;
        }
        if (password.value.match(this.PSW_MATCH_4)) {
            count++;
        }

        if (count < 3) {
            this.showAnInvalidFeedback(password, 'format_password_validation');

            password.classList.remove('is-valid');
            password.classList.add('is-invalid');
            return false;
        } else {
            password.classList.remove('is-invalid');
            password.classList.add('is-valid');
            return true;
        }
    }

    showAnInvalidFeedback(input, classname) {
        let invalid_banner = input.parentElement.querySelector('.invalid-feedback');

        invalid_banner.querySelectorAll('div').forEach(element => {
            element.hidden = !element.classList.contains(classname);
        });
    }

    createInput(form, label, preference, type) {
        var input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", `${type}[note][${label}]`);
        input.setAttribute("value", preference);
        form.appendChild(input);
    }
}

Shopify.form_validator = new FormValidator();